<template>
    <div class="ah-page accounting-voucher-list">
        <div class="page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>傳票作業清單</h1>
                    </div>
                    <div v-if="isAuth('G01')" class="actions">
                        <el-button v-if="isAuth('G06')" size="" @click="onBatchModifyAccountItems">科目置換</el-button>
                        <el-button v-if="isAuth('G12')" size="" @click="onForwardYear" icon="el-icon-tickets">結算年度</el-button>
                        <el-button v-if="isAuth('G06')" size="" @click="onAddEmptyVoucher" type="highlight" icon="el-icon-plus">新增空白傳票</el-button>
                    </div>
                </div>
            </div>
            <div style="height: 80px"></div>
        </div>
        <div class="row" style="margin-top: -85px; margin-bottom: -32px">
            <div class="ah-container">
                <div class="ah-panel">
                    <div class="panel-body">
                        <search-form>
                            <search-form-item label="傳票日期範圍">
                                <ahDropdownDatePicker v-model="dateRange" @change="onDateRangeChange" />
                            </search-form-item>
                            <search-form-item label="帳務類型">
                                <el-select v-model="queryParams.TransactionType" class="type-section" @change="onTransactionTypeChange">
                                    <el-option :key="0" :value="null" label="全部"></el-option>
                                    <el-option v-for="t in transactionType" :key="t.key" :value="t.key" :label="t.label">
                                        <span>{{ t.label }}</span>
                                    </el-option>
                                </el-select>
                            </search-form-item>
                            <search-form-item label="傳票狀態">
                                <el-select v-model="queryParams.Status" @change="onStatusChange">
                                    <el-option :key="null" :value="null" label="全部"></el-option>
                                    <el-option :key="1" :value="1" label="已核准"></el-option>
                                    <el-option :key="0" :value="0" label="待辦"></el-option>
                                </el-select>
                            </search-form-item>
                            <search-form-item label="作廢狀態">
                                <el-radio v-model="queryParams.Cnl" :label="false" @change="onCnlChange">未作廢</el-radio>
                                <el-radio v-model="queryParams.Cnl" :label="true" @change="onCnlChange">已作廢</el-radio>
                            </search-form-item>
                            <search-form-item label="傳票號碼">
                                <div class="horizontal-inputs">
                                    <el-input v-model="queryParams.SerialNumber" style="width: 300px" />
                                    <el-button type="primary" :loading="isLoading" @click="onSubmit" icon="el-icon-search">查詢</el-button>
                                </div>
                            </search-form-item>
                        </search-form>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 40px">
            <div class="ah-container">
                <div class="ah-panel">
                    <div class="panel-body" style="padding: 20px 50px">
                        <div class="action-section">
                            <div>
                                <el-button
                                    v-if="isAuth('G09') && selectedItems.length"
                                    size="small"
                                    type="primary"
                                    :loading="isLoading"
                                    :plain="isBatchApprove ? 'primary' : ''"
                                    :icon="isBatchApprove ? 'el-icon-check' : 'el-icon-refresh-right'"
                                    @click="onBatchUpdateVoucherStatus"
                                >
                                    批次{{ isBatchApprove ? "" : "取消" }}核准 ({{ selectedItems.length }})
                                </el-button>
                                <el-button v-if="isAuth('G09') && selectedItems.length" size="small" @click="onCancelBatch">取消選取</el-button>
                                <span style="font-size: 10pt; color: #888; margin-left: 10px">共 {{ totalDataCount }} 張傳票</span>
                            </div>
                            <el-button size="small" :loading="isLoading" @click="onExportExcel" icon="el-icon-download">匯出傳票明細（日記帳）Excel</el-button>
                        </div>
                        <ah-sticky-el-table-header>
                            <el-table v-loading="isLoading" :data="datas" ref="table" empty-text="沒有資料" @row-click="onRowClick" @selection-change="onSelectChange">
                                <el-table-column type="selection" width="42" key="checkbox"> </el-table-column>
                                <el-table-column prop="serialNumber" label="傳票號碼" width="120" />
                                <el-table-column prop="dat" label="傳票日期" width="100">
                                    <template slot-scope="scope">
                                        <div>{{ getChineseDate(scope.row.dat) }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="傳票狀態" width="80">
                                    <template slot-scope="scope">
                                        <ah-voucher-status-label :status="scope.row.status" />
                                    </template>
                                </el-table-column>
                                <el-table-column prop="transactionType" label="帳務類型">
                                    <template slot-scope="scope">
                                        <span v-if="!scope.row.includeInReport" class="not-included-label">未列入報表</span>
                                        <span v-if="scope.row.cnl">（已作廢）</span>
                                        <span>{{ transactionTypeToName(scope.row) }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="crD_NTD" label="借方金額" align="right">
                                    <template slot-scope="scope">
                                        <Money :v="scope.row.crD_NTD" />
                                    </template>
                                </el-table-column>
                                <el-table-column prop="deB_NTD" label="貸方金額" align="right">
                                    <template slot-scope="scope">
                                        <Money :v="scope.row.deB_NTD" />
                                    </template>
                                </el-table-column>
                            </el-table>
                        </ah-sticky-el-table-header>
                        <div class="pagination">
                            <el-pagination
                                layout="prev, pager, next"
                                :page-size.sync="queryParams.PageSize"
                                :total.sync="totalDataCount"
                                :current-page.sync="queryParams.PageNum"
                                @current-change="updateData"
                            >
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <VoucherDetail
            ref="voucherDetail"
            :visible="voucherDetail.visible"
            :vono="voucherDetail.vono"
            :QueryType="voucherDetail.queryType"
            @close="onVoucherDetailCLose"
            @duplicate="onVoucherDuplicate"
        />
        <YearVoucherDetail :visible="yearVoucherDetail.visible" :forwardYear="forwardYear" @close="onYearVoucherDetailCLose" />
        <BatchModifyAccountItemsDialog
            :visible="batchModifyAccountItemsDialog.visible"
            :parentDateRange="dateRange"
            :transactionTypeToName="transactionTypeToName"
            @close="onBatchModifyAccountItemsCLose"
            @row-click="onRowClick"
        />
    </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { transactionType } from '@/assets/commonData/options';
import VoucherDetail from '@/components/dashboard/Accounting/AccountingVoucherList/ui/VoucherDetail.vue';
import YearVoucherDetail from '@/components/dashboard/Accounting/AccountingVoucherList/ui/YearVoucherDetail.vue';
import BatchModifyAccountItemsDialog from '@/components/dashboard/Accounting/AccountingVoucherList/ui/BatchModifyAccountItemsDialog.vue';
import ahStickyElTableHeader from '@/components/ui/ahStickyElTableHeader.vue';
import ahDropdownDatePicker from '@/components/ui/ahDropdownDatePicker.vue';
import ahVoucherStatusLabel from '@/components/ui/ahVoucherStatusLabel.vue';
import SearchForm from '@/components/ui/SearchForm/SearchForm.vue';
import SearchFormItem from '@/components/ui/SearchForm/SearchFormItem.vue';
import { downloadExcel } from './exportExcelUtils';

export default {
    name: 'AccountingVoucherList',
    components: {
        VoucherDetail,
        YearVoucherDetail,
        BatchModifyAccountItemsDialog,
        ahStickyElTableHeader,
        ahVoucherStatusLabel,
        ahDropdownDatePicker,
        SearchForm,
        SearchFormItem,
    },
    data() {
        return {
            selectedItems: [],
            transactionType,
            yearOptions: [],
            isLoading: false,
            queryParams: {
                UNT_NBR: null, // 原單據系統單號：前端暫時不用
                SerialNumber: null,
                StartDateStart: null,
                StartDateEnd: null,
                TransactionType: null,
                Status: null,
                Cnl: false,
                PageSize: 25,
                PageNum: 1,
            },
            dateRange: [null, null],
            totalDataCount: 0,
            datas: [],
            voucherDetail: {
                visible: false,
                transactionType: null,
                vono: null,
                queryType: null,
            },
            yearVoucherDetail: {
                visible: false,
                transactionType: null,
                vono: null,
            },
            batchModifyAccountItemsDialog: {
                visible: false,
                vono: null,
            },
        };
    },
    computed: {
        forwardYear() {
            return moment(this.queryParams.StartDateStart).year() - 1911;
        },
        isStartEndDateSameYear() {
            return moment(Number(this.dateRange[0])).year() === moment(Number(this.dateRange[1])).year();
        },
        isBatchApprove() {
            return _.find(this.selectedItems, ['status', 0]);
        },
        companyName() {
            return this.$store.getters['menu/companyInfo'].cH_CMP;
        },
    },
    mounted() {
        this.init();
        this.updateData();
    },
    methods: {
        init() {
            this.$store.dispatch('accounting/updateAccountingSettings');

            const THIS_YEAR = moment().year();
            const today = moment();

            for (let y = THIS_YEAR + 1; y >= 2021; y -= 1) {
                this.yearOptions.push({ label: `${y - 1911} 年`, value: y });
            }

            this.year = THIS_YEAR;
            this.dateRange = [today.startOf('year').format('x'), today.endOf('year').format('x')];
        },
        onDateRangeChange() {
            this.queryParams.PageNum = 1;
            this.updateData();
        },
        onTransactionTypeChange() {
            this.queryParams.PageNum = 1;
            this.updateData();
        },
        onSubmit() {
            this.queryParams.PageNum = 1;
            this.updateData();
        },
        updateQuery() {
            this.queryParams.StartDateStart = Number(_.head(this.dateRange));
            this.queryParams.StartDateEnd = Number(_.last(this.dateRange));
        },
        async updateData() {
            if (!this.isStartEndDateSameYear) {
                this.$message({
                    showClose: true,
                    message: '不可跨年度查詢，請重新選擇日期範圍。',
                    type: 'error',
                });
                return;
            }
            this.updateQuery();

            try {
                this.isLoading = true;
                const resp = await this.$api({
                    url: 'AccountingSummaryPage/QueryVouchers',
                    method: 'GET',
                    params: this.queryParams,
                });
                this.datas = resp.data.items;
                this.totalDataCount = resp.data.totalNum;
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },
        onVoucherDetailCLose(refresh) {
            // if (this.voucherDetail.queryType === 11) this.onAfterEmptyVoucherSubmit();

            this.voucherDetail.visible = false;
            this.voucherDetail.vono = null;
            this.voucherDetail.transactionType = null;
            this.voucherDetail.queryType = null;
            if (refresh) {
                this.updateData();
            }
        },
        onVoucherDuplicate(voucher) {
            const sourceData = JSON.parse(JSON.stringify(voucher));
            this.onVoucherDetailCLose();
            setTimeout(() => {
                this.onAddEmptyVoucher(sourceData);
            }, 10);
        },
        onYearVoucherDetailCLose(refresh) {
            this.yearVoucherDetail.visible = false;
            if (refresh) {
                this.updateData();
            }
        },
        // onAfterEmptyVoucherSubmit() {
        //     this.dateRange = [
        //         moment(this.queryParams.StartDateStart)
        //             .startOf('year')
        //             .format('x'),
        //         moment(this.queryParams.StartDateStart)
        //             .endOf('year')
        //             .format('x'),
        //     ];
        //     // this.queryParams.TransactionType = 11; // 11:空白
        //     this.onSubmit();
        // },
        onRowClick(data) {
            this.voucherDetail.visible = true;
            this.voucherDetail.vono = data.vono;
            this.voucherDetail.transactionType = data.transactionType;
        },
        transactionTypeToName(row) {
            if (row.unT_NBR.includes('FORWARD')) return '結帳';
            if (row.unT_NBR.includes('INITIAL')) return '開帳';

            const transaction = this.transactionType.find((t) => t.key === row.transactionType);
            return transaction?.label;
        },
        onForwardYear() {
            this.yearVoucherDetail.visible = true;
        },
        onAddEmptyVoucher(copyVoucher) {
            this.voucherDetail.visible = true;
            this.voucherDetail.vono = null;
            this.voucherDetail.queryType = 11; // 11:空白

            if (copyVoucher) {
                this.$refs.voucherDetail.applyItems(copyVoucher.accountItems);
            }
        },

        onBatchModifyAccountItems() {
            this.batchModifyAccountItemsDialog.visible = true;
        },
        onBatchModifyAccountItemsCLose() {
            this.batchModifyAccountItemsDialog.visible = false;
        },

        onSelectChange(selected) {
            this.selectedItems = selected;
        },
        onCancelBatch() {
            this.$refs.table.clearSelection();
        },
        async onBatchUpdateVoucherStatus() {
            const SET_TO = this.isBatchApprove ? 1 : 0;
            const data = _.map(this.selectedItems, (o) => ({ sno: o.sno, status: SET_TO }));

            try {
                this.isLoading = true;
                await this.$api({
                    url: '/AccountingSummaryPage/UpdateVoucherStatus',
                    method: 'POST',
                    data,
                });
                this.$message({ showClose: true, message: this.isBatchApprove ? '傳票已核准' : '已取消核准', type: 'success' });
                await this.updateData();
            } catch (ex) {
                this.$message({ showClose: true, message: '無法核准傳票', type: 'error' });
            } finally {
                this.isLoading = false;
            }
        },
        getChineseDate(timestamp) {
            const day = moment(timestamp);
            const y = day.year() - 1911;
            const md = day.format('MM-DD');
            return `${y}-${md}`;
        },
        onExportExcel() {
            downloadExcel(this.queryParams, this.companyName, null);
        },
        onStatusChange() {
            this.queryParams.PageNum = 1;
            this.updateData();
        },
        onCnlChange() {
            this.queryParams.PageNum = 1;
            this.updateData();
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.accounting-voucher-list {
    &.ah-page {
        padding-bottom: 15px;
    }
    .action-section {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }
    .query-section {
        display: flex;
        gap: 30px;
        padding: 5px 30px 10px 30px;
        align-items: end;

        .query-item-block {
            .label {
                font-size: 10.5pt;
                color: #606266;
                margin-bottom: 5px;
            }
            &.voucherNumber {
                flex-grow: 1;
            }
            &.submits > .el-button {
                width: 150px;
            }
            .el-input__inner {
                border-width: 2px;
            }
        }
        .query-date-input-set {
            display: flex;
            gap: 5px;
            align-items: center;
            color: #606266;
            font-size: 10pt;

            .el-input__inner {
                text-align: center;
            }
        }
    }
    .pagination {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        background-color: #fff;
    }
    .not-included-label {
        font-size: 9pt;
        color: red;
        border-radius: 3px;
        border: 1px solid red;
        padding: 3px 6px;
        margin-right: 5px;
    }
}
</style>
